import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'avatarLetters',
})
export class AvatarLettersPipe implements PipeTransform {
    transform(fullName: string): string {
        return fullName
            .split(' ')
            .map((n) => n[0])
            .join('');
    }
}
